import { createFileRoute } from "@tanstack/react-router";
import { PageContent } from "@/components/layout/page-content";
import { DangerZone } from "@/features/account/components/danger-zone";
import { LanguageCard } from "@/features/account/components/language-card";
import { OrganizationsCard } from "@/features/account/components/organizations-card";
import { ProfileCard } from "@/features/account/components/profile-card";
import { useMe } from "@/hooks/use-me";
import { useUser } from "@/hooks/use-user";

export const Route = createFileRoute("/(dashboard)/account/")({
	component: ProfilePage,
});

function ProfilePage() {
	const { user, signOut } = useUser();
	const me = useMe();
	const pictureUrl = me?.pictureUrl || user.profilePictureUrl;

	return (
		<PageContent title="Profile">
			<div className="space-y-6">
				<div className="flex flex-col gap-2">
					<h2 className="text-2xl font-bold">Profile</h2>
					<p className="text-muted-foreground">
						Manage your profile and account settings.
					</p>
				</div>

				<ProfileCard user={user} pictureUrl={pictureUrl} />
				<LanguageCard />
				<OrganizationsCard />
				<DangerZone onSignOut={signOut} />
			</div>
		</PageContent>
	);
}
